import { useIsControl } from '@calendly/ui/components/select';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { MembershipInfo } from 'features/user_info';
const paddedControlCss = "p1jo3sx2";
const PaddedControl = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paddedControlCss, props.className)} />;
});
export const AdminMembershipInfo = ({
  adminMembership
}) => {
  const isControl = useIsControl();
  const adminInfo = <MembershipInfo membership={adminMembership} isAvatarNonInteractive />;
  return isControl ? <PaddedControl>{adminInfo}</PaddedControl> : adminInfo;
};

require("./admin_membership_info.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./admin_membership_info.js");